import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './main-component/App/App';
import * as serviceWorker from './serviceWorker';
import './css/font-awesome.min.css';
import './css/responsive.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import './i18n';
import i18next from 'i18next';

const lang=localStorage.getItem('lang')||'en';
axios.defaults.headers.common['Accept-Language']=lang;
i18next.changeLanguage(lang);
ReactDOM.render(<App />, document.getElementById('root'));
console.log("get default language="+lang);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
